import React, { useState, lazy } from 'react';
import PropTypes from 'prop-types';
import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const Filters = ({
  hasApiStatus,
  callback,
  history,
  fleetCompanyList,
  filterList,
  handleReset,
  values,
  setInitialValues,
}) => {
  const [validationError, setValidationError] = useState('');

  const handleSubmit = (fields) => {
    setValidationError('');
    const finalData = { ...fields, companyId: fields.companyId?.value };

    if (finalData.companyId) {
      Object.keys(finalData).forEach((key) => {
        if (!finalData[key]) delete finalData[key];
      });
      filterList(finalData);
    } else {
      setValidationError('Please select a filter');
    }
  };

  const handleCancel = () => {
    handleReset();
    setInitialValues({ companyId: null });
    setValidationError('');
  };

  return (
    <Form
      type="server"
      direction="row"
      initialValues={{ ...values }}
      className="CSAForms"
      RenderComponent={RenderComponent}
      handleOnSubmit={handleSubmit}
      handleOnCancel={handleCancel}
      customProps={{
        history,
        callback,
        hasApiStatus,
        validationError,
        fleetCompanyList,
        setInitialValues,
      }}
    />
  );
};

Filters.propTypes = {
  hasApiStatus: PropTypes.bool.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  fleetCompanyList: PropTypes.array,
  filterList: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  setInitialValues: PropTypes.func.isRequired,
};

export default Filters;
